import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "vehicle-info-section" }
const _hoisted_2 = { class: "info-grid" }
const _hoisted_3 = { class: "info-block" }
const _hoisted_4 = { class: "info-row" }
const _hoisted_5 = { class: "value-with-edit" }
const _hoisted_6 = { class: "value" }
const _hoisted_7 = { class: "info-row" }
const _hoisted_8 = { class: "value-with-edit" }
const _hoisted_9 = { class: "value" }
const _hoisted_10 = { class: "info-row" }
const _hoisted_11 = { class: "value-with-edit" }
const _hoisted_12 = { class: "value" }
const _hoisted_13 = { class: "info-row" }
const _hoisted_14 = { class: "value-with-edit" }
const _hoisted_15 = { style: {"display":"flex","flex-direction":"column","gap":"4px"} }
const _hoisted_16 = {
  key: 1,
  style: {"color":"#909399","font-size":"12px"}
}
const _hoisted_17 = { class: "info-row" }
const _hoisted_18 = { class: "value-with-edit" }
const _hoisted_19 = { class: "value" }
const _hoisted_20 = { class: "info-row" }
const _hoisted_21 = { class: "value-with-edit" }
const _hoisted_22 = { class: "info-row" }
const _hoisted_23 = { class: "value-with-edit" }
const _hoisted_24 = { class: "value" }
const _hoisted_25 = { class: "info-row" }
const _hoisted_26 = { class: "value-with-edit" }
const _hoisted_27 = { class: "value" }
const _hoisted_28 = { class: "info-row" }
const _hoisted_29 = { class: "value-with-edit" }
const _hoisted_30 = { class: "value" }
const _hoisted_31 = { class: "info-row" }
const _hoisted_32 = { class: "value-with-edit" }
const _hoisted_33 = { class: "info-row" }
const _hoisted_34 = { class: "value" }
const _hoisted_35 = {
  key: 0,
  class: "info-row"
}
const _hoisted_36 = { class: "value-with-edit" }
const _hoisted_37 = {
  key: 1,
  class: "info-row"
}
const _hoisted_38 = { class: "value-with-edit" }
const _hoisted_39 = { class: "renter-option" }
const _hoisted_40 = { class: "renter-option__name" }
const _hoisted_41 = { class: "renter-option__phone" }
const _hoisted_42 = { class: "info-row" }
const _hoisted_43 = { class: "value-with-edit" }
const _hoisted_44 = { class: "vehicle-photo-section" }
const _hoisted_45 = { class: "vehicle-images" }
const _hoisted_46 = { class: "images-container" }
const _hoisted_47 = { class: "images-scroll" }
const _hoisted_48 = {
  key: 0,
  class: "image-wrapper"
}
const _hoisted_49 = { class: "image-slot" }
const _hoisted_50 = ["onClick"]
const _hoisted_51 = {
  key: 1,
  class: "image-wrapper"
}
const _hoisted_52 = ["onChange"]
const _hoisted_53 = { class: "upload-placeholder" }
const _hoisted_54 = { class: "image-label" }
const _hoisted_55 = {
  key: 0,
  class: "vehicle-controls"
}
const _hoisted_56 = { class: "control-group" }
const _hoisted_57 = { class: "control-button" }
const _hoisted_58 = { class: "control-button" }
const _hoisted_59 = {
  key: 2,
  class: "status-buttons"
}
const _hoisted_60 = { class: "dialog-footer" }

import {
  computed,
  ref,
  watch,
  watchEffect,
  nextTick,
  onMounted,
  onUnmounted,
} from 'vue'
import { useRouter } from 'vue-router'
import { ElMessageBox, ElMessage } from 'element-plus'
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'
import {
  Lock,
  Unlock,
  Warning,
  Picture,
  Edit,
  PictureFilled,
  User,
  Moon,
} from '@element-plus/icons-vue'
import { ElImage } from 'element-plus'

import {
  EvCarProfileFull,
  EvCarProfileUpdateableKeys,
  EvCarProfileStatus,
  AdminComment,
  EvCarAssignedUser,
} from '@/models/evCarProfile'
import { getAssignmentLabel, ASSIGNABLE_STATUSES } from './helpers'
import { getEvUsers } from '@/api/user'
import { useEvCarsStore } from '@/store/ev-vehicles'
import { routeNames } from '@/router/route-names'
import { RbacAction, RbacEntity } from '@/helpers/rbac'

import { useAuthStore } from '@/store/auth'
import EditableInput from '@/components/EditableInput.vue'
import EditableInputNumber from '@/components/EditableInputNumber.vue'
import useScopeCheck from '@/composables/useScopeCheck'
import evCarsApi from '@/api/car-ev-data'
import evSecurityGroupApi from '@/api/ev-security-group'
import { EvAdmin } from '@/models/evAdmin'


export default /*@__PURE__*/_defineComponent({
  __name: 'VehicleInfoSection',
  props: {
    vehicle: {}
  },
  setup(__props: any) {

const props = __props

const router = useRouter()
const evCarsStore = useEvCarsStore()
const authStore = useAuthStore()

const canLockUnlock = computed(() => {
  const user = authStore.session?.user
  if (!user) return false
  return user.ev_role === 'admin' || user.ev_role === 'super_admin'
})

// Permissions
const allowedEditing = useScopeCheck(RbacAction.UPDATE, RbacEntity.CARS)

// Owner (EV Car Owner Admin) dropdown state
const carOwners = ref<EvAdmin[]>([])
const isOwnerLoading = ref(false)
const isOwnerSaving = ref(false)
const ownerSelected = ref<string>(props.vehicle.owner_ev_car ?? '')

watch(
  () => props.vehicle.owner_ev_car,
  v => {
    ownerSelected.value = v ?? ''
  }
)

const loadCarOwners = async () => {
  if (!allowedEditing) return
  try {
    isOwnerLoading.value = true
    const { data } = await evSecurityGroupApi.carOwnersList()
    carOwners.value = data?.data ?? []
  } catch (e) {
    console.error('Failed to load car owners', e)
  } finally {
    isOwnerLoading.value = false
  }
}

onMounted(loadCarOwners)

const handleOwnerChange = async (value: string | null) => {
  const next = value || null
  if (next === (props.vehicle.owner_ev_car ?? null)) return
  try {
    isOwnerSaving.value = true
    await evCarsStore.updateEvCarOwner(props.vehicle.id, next)
  } catch {
    // Revert on failure
    ownerSelected.value = props.vehicle.owner_ev_car ?? ''
  } finally {
    isOwnerSaving.value = false
  }
}

// Night renter assignment (can be set in advance, takes effect at night_inactive_hour)
const assignmentLabel = computed(() => getAssignmentLabel(props.vehicle))
const activeAssignedUser = computed(() =>
  assignmentLabel.value ? props.vehicle.assigned_user : null
)
const renterOptions = ref<EvCarAssignedUser[]>([])
const assignedUserSelected = ref('')
const isRenterSearching = ref(false)
const isAssigning = ref(false)

watch(
  activeAssignedUser,
  user => {
    assignedUserSelected.value = user?.id ?? ''
    renterOptions.value = user ? [user] : []
  },
  { immediate: true }
)

const formatRenter = (user: EvCarAssignedUser) =>
  `${[user.first_name, user.last_name].filter(Boolean).join(' ')} · ${
    user.phone
  }`

const searchRenters = async (query: string) => {
  if (!query.trim()) return
  try {
    isRenterSearching.value = true
    const { data } = await getEvUsers({ page: 1, perPage: 10, q: query })
    renterOptions.value = data.data
  } catch (e) {
    console.error('Failed to search renters', e)
  } finally {
    isRenterSearching.value = false
  }
}

const handleAssignedUserChange = async (value: string) => {
  const next = value || null
  const current = activeAssignedUser.value?.id ?? null
  if (next === current) return
  try {
    if (!next) {
      await ElMessageBox.confirm(
        'Remove the renter assignment? At night the car will be deactivated unless a trip is in progress.',
        'Night renter',
        { type: 'warning' }
      )
    }
    isAssigning.value = true
    await evCarsStore.setEvCarAssignedUser(props.vehicle.id, next)
  } catch {
    // Cancelled or failed: show the actual assignment again
    assignedUserSelected.value = current ?? ''
  } finally {
    isAssigning.value = false
  }
}

// Loading states
const updatingModule = computed(
  () => evCarsStore.evCarsDetails[props.vehicle.id]?.updating
)
const loadingKeys = computed(() => updatingModule.value?.loadingKeys || [])
const successKeys = computed(() => updatingModule.value?.successKeys || [])
const isStatusUpdating = ref(false)
const isLocking = ref(false)
const isUnlocking = ref(false)

// Image types and management
const imageTypes = [
  'frontImage',
  'backImage',
  'leftImage',
  'rightImage',
  'frontSalonImage',
  'backSalonImage',
  'additionalImage1',
  'additionalImage2',
  'additionalImage3',
  'additionalImage4',
  'additionalImage5',
  'additionalImage6',
]

const mappedImages = computed(() => {
  const map: Record<string, any> = {}
  props.vehicle.images?.forEach(img => (map[img.type] = img))
  return map
})

// Computed properties
const mainVehicleImage = computed(() => props.vehicle.images?.[0] || null)

// Use ref instead of computed for vehicleScore to make it compatible with v-model
const vehicleScore = ref(3.5)

// Update vehicleScore when props.vehicle.rating changes
watchEffect(() => {
  // Ensure we only try to parse if rating is not empty string
  let parsedValue = 3.5
  if (props.vehicle.rating && props.vehicle.rating !== '') {
    parsedValue = Number(props.vehicle.rating)
    if (isNaN(parsedValue)) {
      parsedValue = 3.5
    }
  }
  // Ensure the value is between 0 and 5
  vehicleScore.value = Math.min(Math.max(parsedValue, 0), 5)
})

// Add these new refs for edit dialog
const editDialogVisible = ref(false)
const currentEditField = ref<EvCarProfileUpdateableKeys>('model_make_id')

// Add this new method for handling edit icon clicks
const startEditing = (field: EvCarProfileUpdateableKeys) => {
  currentEditField.value = field
  editDialogVisible.value = true
}

// Methods
const handleSavePress = async (value: any, key: EvCarProfileUpdateableKeys) => {
  try {
    await evCarsStore.updateEvVehicle(props.vehicle.id, { [key]: value })
  } catch (error) {
    console.error('Failed to update vehicle:', error)
  }
}

const updateStatus = async (status: string) => {
  isStatusUpdating.value = true
  try {
    await evCarsStore.updateEvCarStatus(props.vehicle.id, status as any)
    editDialogVisible.value = false
  } catch (error) {
    console.error('Failed to update status:', error)
  } finally {
    isStatusUpdating.value = false
  }
}

// Admin comment functions
const commentDialogVisible = ref(false)
const commentDialogTitle = ref('')
const pendingStatus = ref<EvCarProfileStatus | null>(null)
const commentForm = ref({
  comment: '',
})

const getLatestAdminComment = (): AdminComment | null => {
  const comments = props.vehicle.admin_comment || []
  if (comments.length === 0) return null
  return comments.sort(
    (a, b) =>
      new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
  )[0]
}

const showAdminBlockDialog = () => {
  pendingStatus.value = EvCarProfileStatus.ADMIN_BLOCKED
  commentDialogTitle.value = 'Block EV Car - Admin Action'
  commentForm.value.comment = ''
  commentDialogVisible.value = true
}

const showAdminUnblockDialog = () => {
  pendingStatus.value = EvCarProfileStatus.ACTIVE
  commentDialogTitle.value = 'Unblock EV Car - Admin Action'
  commentForm.value.comment = ''
  commentDialogVisible.value = true
}

const showAdminActiveDialog = () => {
  pendingStatus.value = EvCarProfileStatus.ADMIN_ACTIVE
  commentDialogTitle.value = 'Admin Active - Admin Action'
  commentForm.value.comment = ''
  commentDialogVisible.value = true
}

const showDeactivateAdminActiveDialog = () => {
  pendingStatus.value = EvCarProfileStatus.ACTIVE
  commentDialogTitle.value = 'Change to Active - Admin Action'
  commentForm.value.comment = ''
  commentDialogVisible.value = true
}

const showAdminDeactivateDialog = () => {
  pendingStatus.value = EvCarProfileStatus.INACTIVE
  commentDialogTitle.value = 'Deactivate - Admin Action'
  commentForm.value.comment = ''
  commentDialogVisible.value = true
}

const handleStatusUpdateWithComment = async () => {
  if (!pendingStatus.value || !commentForm.value.comment.trim()) {
    ElMessage.error('Comment is required for this action')
    return
  }

  isStatusUpdating.value = true
  try {
    await evCarsStore.updateEvCarStatus(props.vehicle.id, pendingStatus.value, {
      admin_comment: commentForm.value.comment.trim(),
    })

    ElMessage.success('Status updated successfully')
    commentDialogVisible.value = false
    commentForm.value.comment = ''
    pendingStatus.value = null
    editDialogVisible.value = false
  } catch (error) {
    // Type guard to check if error has response property
    if (error && typeof error === 'object' && 'response' in error) {
      const err = error as {
        response?: {
          status?: number
          data?: { code?: string; message?: string }
        }
      }
      if (
        err.response?.status === 422 &&
        err.response?.data?.code === 'ADMIN_COMMENT_REQUIRED'
      ) {
        ElMessage.error('Admin comment is required for this action')
      } else {
        ElMessage.error(
          err.response?.data?.message || 'Failed to update status'
        )
      }
    } else {
      ElMessage.error('Failed to update status')
    }
  } finally {
    isStatusUpdating.value = false
  }
}

const formatStatus = (status: string) => {
  switch (status) {
    case 'active':
      return 'Available'
    case 'inactive':
      return 'Inactive'
    case 'admin_blocked':
      return 'Admin Blocked'
    case 'admin_active':
      return 'Admin Active'
    case 'verifying':
      return 'Verifying'
    case 'incomplete':
      return 'Incomplete'
    default:
      return status
  }
}

const getStatusTagType = (status: string) => {
  switch (status) {
    case 'active':
      return 'success'
    case 'inactive':
      return 'warning'
    case 'admin_blocked':
      return 'danger'
    case 'admin_active':
      return 'primary'
    case 'verifying':
      return 'info'
    default:
      return 'info'
  }
}

const getBatteryColor = (level: number) => {
  if (level <= 25) return '#F56C6C'
  if (level <= 50) return '#E6A23C'
  return '#67C23A'
}

const showOnMap = async () => {
  mapDialogVisible.value = true
  await nextTick()
  initializeMap()
}

const lockVehicle = async () => {
  if (!canLockUnlock.value) return
  isLocking.value = true
  try {
    // Optimistically update UI
    const updatedVehicle = { ...props.vehicle, status_doors: false }

    const res = await evCarsApi.controlEvCarDoors(props.vehicle.id, 'lock')

    // Refresh vehicle data from store
    await evCarsStore.getEvCarDetails(props.vehicle.id)
  } catch (error) {
    // Refresh to get accurate status on error
    await evCarsStore.getEvCarDetails(props.vehicle.id)
  } finally {
    isLocking.value = false
  }
}

const unlockVehicle = async () => {
  if (!canLockUnlock.value) return
  isUnlocking.value = true
  try {
    const res = await evCarsApi.controlEvCarDoors(props.vehicle.id, 'unlock')

    // Follow the same pattern as GeotekControlSection - send unlock command twice with delay
    await new Promise(r => setTimeout(r, 1500))
    await evCarsApi.controlEvCarDoors(props.vehicle.id, 'unlock')

    // Refresh vehicle data from store
    await evCarsStore.getEvCarDetails(props.vehicle.id)
  } catch (error) {
    console.error('Failed to unlock vehicle:', error)
    // Refresh to get accurate status on error
    await evCarsStore.getEvCarDetails(props.vehicle.id)
  } finally {
    isUnlocking.value = false
  }
}

const handleImageUpload = async (event: Event, type: string) => {
  const file = (event.target as HTMLInputElement).files?.[0]
  if (!file) return

  try {
    const uploaded = await evCarsStore.uploadImg(props.vehicle.id, file, type)
  } catch (err) {
    console.error('Upload failed', err)
  }
}

const confirmImageDelete = async (imageId: string) => {
  try {
    await ElMessageBox.confirm(
      'Do you really want to delete this image?',
      'Warning',
      {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning',
      }
    )
    await evCarsStore.deleteEvCarImage(props.vehicle.id, imageId)
  } catch (err) {
    console.error('Image delete canceled')
  }
}

const formatImageType = (type: string) => {
  const typeMap: Record<string, string> = {
    frontImage: 'Front',
    backImage: 'Back',
    leftImage: 'Left',
    rightImage: 'Right',
    frontSalonImage: 'Front Salon',
    backSalonImage: 'Back Salon',
    additionalImage1: 'Additional 1',
    additionalImage2: 'Additional 2',
    additionalImage3: 'Additional 3',
    additionalImage4: 'Additional 4',
    additionalImage5: 'Additional 5',
    additionalImage6: 'Additional 6',
  }
  return typeMap[type] || type
}

// Map related
const mapDialogVisible = ref(false)
const mapContainer = ref<HTMLElement | null>(null)
const leafletMap = ref<L.Map | null>(null)

const initializeMap = () => {
  if (!mapContainer.value) {
    console.error('Map container not found')
    return
  }

  if (!props.vehicle.location) {
    console.error('Vehicle location missing')
    return
  }

  const lat = Number(props.vehicle.location.lat)
  const lng = Number(props.vehicle.location.lng)

  if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
    console.error('Invalid coordinates')
    return
  }

  if (leafletMap.value) {
    leafletMap.value.remove()
    leafletMap.value = null
  }

  // Fix Leaflet icon paths
  delete (L.Icon.Default.prototype as any)._getIconUrl
  L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
  })

  const map = L.map(mapContainer.value).setView([lat, lng], 15)
  leafletMap.value = map

  L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    maxZoom: 19,
    attribution: '&copy; OpenStreetMap contributors',
  }).addTo(map)

  L.marker([lat, lng]).addTo(map)

  // Force map invalidation to ensure tiles render correctly in modal
  setTimeout(() => {
    map.invalidateSize()
  }, 100)
}

onUnmounted(() => {
  if (leafletMap.value) {
    leafletMap.value.remove()
    leafletMap.value = null
  }
})

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_rate = _resolveComponent("el-rate")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[47] || (_cache[47] = _createElementVNode("h4", { class: "section-title" }, "VEHICLE INFO", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[18] || (_cache[18] = _createElementVNode("span", { class: "label" }, "Make", -1)),
          _createElementVNode("div", _hoisted_5, [
            (_unref(allowedEditing))
              ? (_openBlock(), _createBlock(_component_el_icon, {
                  key: 0,
                  class: "edit-icon",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (startEditing('model_make_id')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Edit))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.vehicle.model_make_id), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _cache[19] || (_cache[19] = _createElementVNode("span", { class: "label" }, "Model", -1)),
          _createElementVNode("div", _hoisted_8, [
            (_unref(allowedEditing))
              ? (_openBlock(), _createBlock(_component_el_icon, {
                  key: 0,
                  class: "edit-icon",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (startEditing('model_name')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Edit))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.vehicle.model_name), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _cache[20] || (_cache[20] = _createElementVNode("span", { class: "label" }, "Year", -1)),
          _createElementVNode("div", _hoisted_11, [
            (_unref(allowedEditing))
              ? (_openBlock(), _createBlock(_component_el_icon, {
                  key: 0,
                  class: "edit-icon",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (startEditing('model_year')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Edit))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.vehicle.model_year), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _cache[21] || (_cache[21] = _createElementVNode("span", { class: "label" }, "Status", -1)),
          _createElementVNode("div", _hoisted_14, [
            (_unref(allowedEditing))
              ? (_openBlock(), _createBlock(_component_el_icon, {
                  key: 0,
                  class: "edit-icon",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (startEditing('status')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Edit))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_el_tag, {
                type: getStatusTagType(_ctx.vehicle.status)
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(formatStatus(_ctx.vehicle.status)), 1)
                ]),
                _: 1
              }, 8, ["type"]),
              (assignmentLabel.value)
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 0,
                    type: "warning"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(assignmentLabel.value), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (getLatestAdminComment())
                ? (_openBlock(), _createElementBlock("span", _hoisted_16, " (" + _toDisplayString(getLatestAdminComment()?.comment) + ") ", 1))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _cache[22] || (_cache[22] = _createElementVNode("span", { class: "label" }, "Plate Number", -1)),
          _createElementVNode("div", _hoisted_18, [
            (_unref(allowedEditing))
              ? (_openBlock(), _createBlock(_component_el_icon, {
                  key: 0,
                  class: "edit-icon",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (startEditing('plate_number')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Edit))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.vehicle.plate_number), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _cache[23] || (_cache[23] = _createElementVNode("span", { class: "label" }, "Energy Level", -1)),
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_el_progress, {
              percentage: _ctx.vehicle.electric_level || 0,
              color: getBatteryColor(_ctx.vehicle.electric_level),
              status: _ctx.vehicle.electric_level <= 25 ? 'exception' : undefined
            }, null, 8, ["percentage", "color", "status"])
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _cache[24] || (_cache[24] = _createElementVNode("span", { class: "label" }, "Distance Level", -1)),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.vehicle.range_per_charge || 'N/A') + " km", 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _cache[25] || (_cache[25] = _createElementVNode("span", { class: "label" }, "Current Odometer", -1)),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.vehicle.odometer_indicators || '0') + " km", 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_28, [
          _cache[26] || (_cache[26] = _createElementVNode("span", { class: "label" }, "Connector Type", -1)),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.vehicle.charging_connector_type || '—'), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_31, [
          _cache[28] || (_cache[28] = _createElementVNode("span", { class: "label" }, "Map", -1)),
          _createElementVNode("div", _hoisted_32, [
            _createVNode(_component_el_button, {
              type: "primary",
              plain: "",
              size: "small",
              onClick: showOnMap
            }, {
              default: _withCtx(() => _cache[27] || (_cache[27] = [
                _createTextVNode("Map")
              ])),
              _: 1,
              __: [27]
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_33, [
          _cache[29] || (_cache[29] = _createElementVNode("span", { class: "label" }, "Address", -1)),
          _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.vehicle.address || '—'), 1)
        ]),
        (_unref(allowedEditing))
          ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
              _cache[30] || (_cache[30] = _createElementVNode("span", { class: "label" }, "Owner", -1)),
              _createElementVNode("div", _hoisted_36, [
                _createVNode(_component_el_select, {
                  modelValue: ownerSelected.value,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((ownerSelected).value = $event)),
                  placeholder: "— None —",
                  clearable: "",
                  filterable: "",
                  loading: isOwnerLoading.value,
                  disabled: isOwnerSaving.value,
                  class: "rb-field-select",
                  onChange: handleOwnerChange
                }, {
                  prefix: _withCtx(() => [
                    _createVNode(_component_el_icon, { class: "rb-field-select__icon" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(User))
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(carOwners.value, (o) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: o.id,
                        label: o.email,
                        value: o.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "loading", "disabled"])
              ])
            ]))
          : _createCommentVNode("", true),
        (
            _unref(allowedEditing) &&
              _unref(ASSIGNABLE_STATUSES).includes(_ctx.vehicle.status as EvCarProfileStatus)
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
              _cache[31] || (_cache[31] = _createElementVNode("span", { class: "label" }, "Night renter", -1)),
              _createElementVNode("div", _hoisted_38, [
                _createVNode(_component_el_select, {
                  modelValue: assignedUserSelected.value,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((assignedUserSelected).value = $event)),
                  placeholder: "Search by name or phone",
                  clearable: "",
                  filterable: "",
                  remote: "",
                  "remote-method": searchRenters,
                  loading: isRenterSearching.value,
                  disabled: isAssigning.value,
                  "no-data-text": "No renters found",
                  class: _normalizeClass(["rb-field-select", { 'is-assigned': activeAssignedUser.value }]),
                  onChange: handleAssignedUserChange
                }, {
                  prefix: _withCtx(() => [
                    _createVNode(_component_el_icon, { class: "rb-field-select__icon" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Moon))
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(renterOptions.value, (u) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: u.id,
                        label: formatRenter(u),
                        value: u.id
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_39, [
                            _createElementVNode("span", _hoisted_40, _toDisplayString([u.first_name, u.last_name].filter(Boolean).join(' ')), 1),
                            _createElementVNode("span", _hoisted_41, _toDisplayString(u.phone), 1)
                          ])
                        ]),
                        _: 2
                      }, 1032, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "loading", "disabled", "class"])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_42, [
          _cache[32] || (_cache[32] = _createElementVNode("span", { class: "label" }, "Score", -1)),
          _createElementVNode("div", _hoisted_43, [
            _createVNode(_component_el_rate, {
              "model-value": vehicleScore.value,
              disabled: "",
              "show-score": "",
              "text-color": "#ff9900",
              colors: ['#ff9900', '#ff9900', '#ff9900'],
              "void-color": "#c6d1de",
              max: 5
            }, null, 8, ["model-value"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_44, [
        _createElementVNode("div", _hoisted_45, [
          _cache[34] || (_cache[34] = _createElementVNode("h5", { class: "images-title" }, "Vehicle Images", -1)),
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("div", _hoisted_47, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(imageTypes, (type) => {
                return _createElementVNode("div", {
                  key: type,
                  class: "upload-container"
                }, [
                  (mappedImages.value[type])
                    ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                        _createVNode(_unref(ElImage), {
                          src: mappedImages.value[type].secure_url,
                          "preview-src-list": [mappedImages.value[type].secure_url],
                          fit: "cover",
                          "initial-index": 0,
                          "preview-teleported": ""
                        }, {
                          error: _withCtx(() => [
                            _createElementVNode("div", _hoisted_49, [
                              _createVNode(_component_el_icon, { class: "image-slot-icon" }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(PictureFilled))
                                ]),
                                _: 1
                              }),
                              _cache[33] || (_cache[33] = _createElementVNode("span", { class: "image-slot-text" }, "Image not available", -1))
                            ])
                          ]),
                          _: 2
                        }, 1032, ["src", "preview-src-list"]),
                        (_unref(allowedEditing))
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "remove-button",
                              onClick: ($event: any) => (confirmImageDelete(mappedImages.value[type].id))
                            }, " X ", 8, _hoisted_50))
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_51, [
                        (_unref(allowedEditing))
                          ? (_openBlock(), _createElementBlock("input", {
                              key: 0,
                              type: "file",
                              class: "upload-input",
                              onChange: ($event: any) => (handleImageUpload($event, type))
                            }, null, 40, _hoisted_52))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_53, [
                          _createVNode(_component_el_icon, { size: 24 }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(Picture))
                            ]),
                            _: 1
                          })
                        ])
                      ])),
                  _createElementVNode("p", _hoisted_54, _toDisplayString(formatImageType(type)), 1)
                ])
              }), 64))
            ])
          ])
        ]),
        (canLockUnlock.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
              _createElementVNode("div", _hoisted_56, [
                _createElementVNode("div", _hoisted_57, [
                  _createVNode(_component_el_button, {
                    type: "warning",
                    circle: "",
                    size: "large",
                    loading: isLocking.value,
                    onClick: lockVehicle,
                    class: "lock-btn",
                    disabled: !canLockUnlock.value || !_ctx.vehicle.status_doors
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Lock))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["loading", "disabled"]),
                  _cache[35] || (_cache[35] = _createElementVNode("span", { class: "control-label" }, "Lock", -1))
                ]),
                _createElementVNode("div", _hoisted_58, [
                  _createVNode(_component_el_button, {
                    type: "success",
                    circle: "",
                    size: "large",
                    loading: isUnlocking.value,
                    onClick: unlockVehicle,
                    class: "unlock-btn",
                    disabled: !canLockUnlock.value || _ctx.vehicle.status_doors
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Unlock))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["loading", "disabled"]),
                  _cache[36] || (_cache[36] = _createElementVNode("span", { class: "control-label" }, "Unlock", -1))
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: editDialogVisible.value,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((editDialogVisible).value = $event)),
      title: `Edit ${currentEditField.value}`,
      width: "30%"
    }, {
      default: _withCtx(() => [
        (
          !['model_year', 'status'].includes(currentEditField.value) &&
            typeof _ctx.vehicle[currentEditField.value] === 'string'
        )
          ? (_openBlock(), _createBlock(EditableInput, {
              key: 0,
              editable: true,
              sourceValue: _ctx.vehicle[currentEditField.value] as string,
              loading: loadingKeys.value.includes(currentEditField.value),
              success: successKeys.value.includes(currentEditField.value),
              onSave: _cache[7] || (_cache[7] = ($event: any) => (handleSavePress($event, currentEditField.value))),
              onCancel: _cache[8] || (_cache[8] = ($event: any) => (editDialogVisible.value = false))
            }, null, 8, ["sourceValue", "loading", "success"]))
          : (currentEditField.value === 'model_year')
            ? (_openBlock(), _createBlock(EditableInputNumber, {
                key: 1,
                editable: true,
                sourceValue: _ctx.vehicle[currentEditField.value] as number,
                loading: loadingKeys.value.includes(currentEditField.value),
                success: successKeys.value.includes(currentEditField.value),
                onSave: _cache[9] || (_cache[9] = ($event: any) => (handleSavePress($event, currentEditField.value))),
                onCancel: _cache[10] || (_cache[10] = ($event: any) => (editDialogVisible.value = false))
              }, null, 8, ["sourceValue", "loading", "success"]))
            : (currentEditField.value === 'status')
              ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                  (
            _ctx.vehicle.status !== 'active' && _ctx.vehicle.status !== 'admin_active'
          )
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        type: "success",
                        loading: isStatusUpdating.value,
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (updateStatus('active')))
                      }, {
                        default: _withCtx(() => _cache[37] || (_cache[37] = [
                          _createTextVNode(" Activate ")
                        ])),
                        _: 1,
                        __: [37]
                      }, 8, ["loading"]))
                    : _createCommentVNode("", true),
                  (_ctx.vehicle.status === 'active')
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 1,
                        type: "danger",
                        loading: isStatusUpdating.value,
                        onClick: _cache[12] || (_cache[12] = ($event: any) => (updateStatus('inactive')))
                      }, {
                        default: _withCtx(() => _cache[38] || (_cache[38] = [
                          _createTextVNode(" Deactivate ")
                        ])),
                        _: 1,
                        __: [38]
                      }, 8, ["loading"]))
                    : _createCommentVNode("", true),
                  (
            ['active', 'inactive', 'verifying', 'admin_active'].includes(
              _ctx.vehicle.status
            )
          )
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 2,
                        type: "warning",
                        loading: isStatusUpdating.value,
                        onClick: showAdminBlockDialog
                      }, {
                        default: _withCtx(() => _cache[39] || (_cache[39] = [
                          _createTextVNode(" Admin Block ")
                        ])),
                        _: 1,
                        __: [39]
                      }, 8, ["loading"]))
                    : _createCommentVNode("", true),
                  (_ctx.vehicle.status === 'admin_blocked')
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 3,
                        type: "success",
                        loading: isStatusUpdating.value,
                        onClick: showAdminUnblockDialog
                      }, {
                        default: _withCtx(() => _cache[40] || (_cache[40] = [
                          _createTextVNode(" Unblock ")
                        ])),
                        _: 1,
                        __: [40]
                      }, 8, ["loading"]))
                    : _createCommentVNode("", true),
                  (_ctx.vehicle.status === 'admin_blocked')
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 4,
                        type: "danger",
                        loading: isStatusUpdating.value,
                        onClick: showAdminDeactivateDialog
                      }, {
                        default: _withCtx(() => _cache[41] || (_cache[41] = [
                          _createTextVNode(" Deactivate ")
                        ])),
                        _: 1,
                        __: [41]
                      }, 8, ["loading"]))
                    : _createCommentVNode("", true),
                  (['active', 'inactive', 'verifying'].includes(_ctx.vehicle.status))
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 5,
                        type: "info",
                        loading: isStatusUpdating.value,
                        onClick: showAdminActiveDialog
                      }, {
                        default: _withCtx(() => _cache[42] || (_cache[42] = [
                          _createTextVNode(" Admin Active ")
                        ])),
                        _: 1,
                        __: [42]
                      }, 8, ["loading"]))
                    : _createCommentVNode("", true),
                  (_ctx.vehicle.status === 'admin_active')
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 6,
                        type: "primary",
                        loading: isStatusUpdating.value,
                        onClick: showDeactivateAdminActiveDialog
                      }, {
                        default: _withCtx(() => _cache[43] || (_cache[43] = [
                          _createTextVNode(" To Active ")
                        ])),
                        _: 1,
                        __: [43]
                      }, 8, ["loading"]))
                    : _createCommentVNode("", true),
                  (_ctx.vehicle.status === 'admin_active')
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 7,
                        type: "danger",
                        loading: isStatusUpdating.value,
                        onClick: showAdminDeactivateDialog
                      }, {
                        default: _withCtx(() => _cache[44] || (_cache[44] = [
                          _createTextVNode(" Deactivate ")
                        ])),
                        _: 1,
                        __: [44]
                      }, 8, ["loading"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      modelValue: commentDialogVisible.value,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((commentDialogVisible).value = $event)),
      title: commentDialogTitle.value,
      width: "400px"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_60, [
          _createVNode(_component_el_button, {
            onClick: _cache[15] || (_cache[15] = ($event: any) => (commentDialogVisible.value = false))
          }, {
            default: _withCtx(() => _cache[45] || (_cache[45] = [
              _createTextVNode("Cancel")
            ])),
            _: 1,
            __: [45]
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: handleStatusUpdateWithComment,
            loading: isStatusUpdating.value
          }, {
            default: _withCtx(() => _cache[46] || (_cache[46] = [
              _createTextVNode(" Confirm ")
            ])),
            _: 1,
            __: [46]
          }, 8, ["loading"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: commentForm.value,
          "label-width": "120px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "Comment",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: commentForm.value.comment,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((commentForm.value.comment) = $event)),
                  type: "textarea",
                  rows: 4,
                  placeholder: "Please enter the reason for this action...",
                  maxlength: "500",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      modelValue: mapDialogVisible.value,
      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((mapDialogVisible).value = $event)),
      title: "Vehicle Location",
      width: "60%",
      "destroy-on-close": "",
      "align-center": "",
      onOpened: initializeMap
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          ref_key: "mapContainer",
          ref: mapContainer,
          class: "map-container"
        }, null, 512)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})